"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaxHeight = void 0;
const react_1 = require("react");
const useMaxHeight = (ref, status) => {
    const [maxWidth, setMaxWidth] = (0, react_1.useState)('0px');
    (0, react_1.useLayoutEffect)(() => {
        if (status && ref.current) {
            setMaxWidth(`${ref.current.scrollHeight}px`);
        }
        else {
            setMaxWidth('0px');
        }
    }, [status, ref]);
    return maxWidth;
};
exports.useMaxHeight = useMaxHeight;
